import React from 'react';

import { Flores3D } from '../assets';

const Footer = () => {
  return (
    <div className='w-screen lg:px-32 bg-primary bg-opacity-10 p-3'>
        <div className='flex flex-col items-center'>
          <a className='text-[0.79rem] font-bold' href="https://livetech.world" target='_blank' rel='noreferrer'>Powered by Live Tech</a>
          <img src={Flores3D} alt="flores" className='w-24 md:w-96 m-1' /> 
        </div>
    </div>
  )
}

export default Footer